import React from 'react';

import {observer} from "mobx-react";
import {GameStatsWidgetAsync} from "../../../game-stats-widget/components/game-stats-widget.async";
import {PreGameStatsWidgetAsync} from "../../../pre-game-stats-widget/components/pre-game-stats-widget.async";

export const GameCenterWidgetContentStatsTab = observer(({controller, matchupId, gameId, location, showOdds}) => {
  const {state} = controller;
  const {shouldRenderStats, hasShotChart} = state;

  const statsProps = {
    matchupId,
    gameId,
    location,
    showOdds,
    hasShotChart,
    isFullView: true,
  }

  const preGameStatsProps = {
    matchupId,
    gameId,
    location,
    showOdds,
  }

  return (shouldRenderStats ? <>
    {state.game?.isScheduled ? <PreGameStatsWidgetAsync {...preGameStatsProps}/> : <GameStatsWidgetAsync {...statsProps}/>}
  </> : null)
});
